
import React from "react";
import img1 from "../img/SANFRANCISCO.jpg";
import img2 from "../img/SACRAMENTO.jpg";
import img3 from "../img/SANJOSE.jpg";

const AreaList = () => {
    return (
        // <div className="list">
        //     <li><a href="/area-served/redwood-city">Redwood City - </a></li>
        //     <li><a href="/area-served/palo-alto"> Palo Alto - </a></li>
        //     <li><a href="/area-served/cupertino"> Cupertino - </a></li>
        //     <li><a href="/area-served/mountain-view"> Mountain View - </a></li>
        //     <li><a href="/area-served/santa-clara"> Santa Clara - </a></li>
        //     <li><a href="/area-served/san-mateo"> San Mateo - </a></li>
        //     <li><a href="/area-served/burlingame"> Burlingame - </a></li>
        //     <li><a href="/area-served/san-carlos"> San Carlos - </a></li>
        //     <li><a href="/area-served/san-jose"> San Jose - </a></li>
        //     <li><a href="/area-served/menlo-park"> Menlo Park - </a></li>
        //     <li><a href="/area-served/fremont"> Fremont - </a></li>
        //     <li><a href="/area-served/union-city"> Union City - </a></li>
        //     <li><a href="/area-served/castro-valley"> Castro Valley - </a></li>
        //     <li><a href="/area-served/walnut-creek"> Walnut Creek - </a></li>
        //     <li><a href="/area-served/pleasanton"> Pleasanton - </a></li>
        //     <li><a href="/area-served/pleasanton"> San Jose - </a></li>
        //     <li><a href="/area-served/pleasanton"> San Francisco - </a></li>
        //     <li><a href="/area-served/pleasanton"> Sacramento </a></li>
        // </div>
        <div>
            <div className="list">
                <li><img src={img1} /> <a target="_blank" href="https://maps.app.goo.gl/qqWzpg8XJ3dTBzCW9">Sanfrancisco</a></li>
                <li><img src={img2} /> <a target="_blank" href="https://maps.app.goo.gl/HMTdGjWqXfNBSFeQ9?g_st=ic">Sacramento</a></li>
                <li><img src={img3} /> <a target="_blank" href="https://maps.app.goo.gl/GTt33ef8KGcvs7oD6?g_st=ic">Sanjose</a></li>
            </div>
            <div className="row sec1">
                <div className="col-lg-4">
                    <img src={img1} />
                    <a target="_blank" href="https://maps.app.goo.gl/qqWzpg8XJ3dTBzCW9"> Sanfrancisco</a>
                </div>
                <div className="col-lg-4">
                    <img src={img2} />
                    <a target="_blank" href="https://maps.app.goo.gl/HMTdGjWqXfNBSFeQ9?g_st=ic"> Sacramento</a>
                </div>
                <div className="col-lg-4">
                    <img src={img3} />
                    <a target="_blank" href="https://maps.app.goo.gl/GTt33ef8KGcvs7oD6?g_st=ic"> Sanjose</a>
                </div>
            </div>
        </div>
    );
}

export default AreaList;